import { api } from '../api';
import { getStationKey } from './posStation';
import { isNativePrintAvailable, printDocketsNative } from './nativePrint';

/**
 * Print Tyro integrated receipt copies to the counter printer.
 * Prefers native TcpPrint on the POS iPad (Azure cannot reach LAN printers).
 */
export async function printTyroCardReceipt(payRequestId, { which = 'customer' } = {}) {
  if (!payRequestId) throw new Error('Missing pay request id');
  const native = isNativePrintAvailable();
  const result = await api.printEftposReceipt({
    pay_request_id: payRequestId,
    which,
    client_prints: native || undefined,
  }, getStationKey());
  if (native && result?.dockets?.length) {
    await printDocketsNative(result.dockets);
  }
  return result;
}

/** Cert PI-09: print all available copies, retrying briefly while Tyro receipts arrive. */
export async function printTyroCertReceipts(payRequestId, { attempts = 6, delayMs = 1500 } = {}) {
  let lastErr = null;
  for (let i = 0; i < attempts; i += 1) {
    try {
      return await printTyroCardReceipt(payRequestId, { which: 'all' });
    } catch (err) {
      lastErr = err;
      const msg = String(err?.message || '');
      if (!/no tyro receipt/i.test(msg) && !/not found/i.test(msg)) throw err;
      if (i < attempts - 1) {
        await new Promise((r) => setTimeout(r, delayMs));
      }
    }
  }
  throw lastErr || new Error('No Tyro receipt available yet');
}
